module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_H.7db9dd15.jpg";